module.exports = __webpack_public_path__ + "media/images/png/rent-white/4-2218e1ab87244eeaa775b09c4cf9bdad.png";